export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VEHICLES = [
  { id: "s", code: "S", label: "Kleinwagen", example: "z. B. Polo, Corsa" },
  { id: "m", code: "M", label: "Limousine / Kombi", example: "z. B. Golf, 3er BMW" },
  { id: "l", code: "L", label: "SUV / Van", example: "z. B. Tiguan, Touran" },
  { id: "xl", code: "XL", label: "Transporter / Bus", example: "z. B. T5, Vito" },
];

export const VEHICLE_OPTIONS = ["Kleinwagen", "Limousine / Kombi", "SUV / Van", "Transporter / Bus", "Sonstiges"];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnRlcmlvciUyMGxlYXRoZXIlMjBsdXh1cnl8ZW58MHx8fHwxNzkxNDYxMjE4fDA&ixlib=rb-4.1.0&q=85&w=1600",
  aufbereitung: "https://images.unsplash.com/photo-1654267195849-51b783e16fda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxjYXIlMjB1cGhvbHN0ZXJ5JTIwY2xlYW4lMjB2YWN1dW18ZW58MHx8fHwxNzkxNDYxMjE5fDA&ixlib=rb-4.1.0&q=85&w=1200",
  reinigung: "https://images.unsplash.com/photo-1771491237225-01931a752f58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjYXIlMjB1cGhvbHN0ZXJ5JTIwY2xlYW4lMjB2YWN1dW18ZW58MHx8fHwxNzkxNDYxMjE5fDA&ixlib=rb-4.1.0&q=85&w=1200",
  cockpit: "https://images.unsplash.com/photo-1667893591090-19729ae8fee3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXIlMjBkYXNoYm9hcmQlMjBpbnRlcmlvciUyMGRldGFpbHxlbnwwfHx8fDE3OTE0NjEyMTh8MA&ixlib=rb-4.1.0&q=85&w=1200",
  steering: "https://images.unsplash.com/photo-1661336878257-1c51b5af959a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxjYXIlMjBpbnRlcmlvciUyMGxlYXRoZXIlMjBsdXh1cnl8ZW58MHx8fHwxNzkxNDYxMjE4fDA&ixlib=rb-4.1.0&q=85&w=1200",
  cognac: "https://images.unsplash.com/photo-1649136378672-b965cb9935d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxjYXIlMjBpbnRlcmlvciUyMGxlYXRoZXIlMjBsdXh1cnl8ZW58MHx8fHwxNzkxNDYxMjE4fDA&ixlib=rb-4.1.0&q=85&w=1200",
};

export const DEFAULT_CONTENT = {
  texts: {
    hero_overline: "Mobile Innenaufbereitung · Rotenburg (Wümme)",
    hero_title_1: "WIE NEU.",
    hero_title_2: "NUR VON INNEN.",
    hero_sub:
      "Ich reinige und pflege den Innenraum deines Fahrzeugs – komplett mobil bei dir vor Ort: Sitze, Polster, Teppiche und Armaturen. Gern mit Zusatzleistungen wie Lederpflege oder Geruchsentfernung.",
    services_eyebrow: "Leistungen",
    services_title: "Alles für einen gepflegten Innenraum.",
    services_sub:
      "Fokus Innenaufbereitung: Ich bringe Sitze, Polster, Teppiche und Armaturen wieder in Form – mobil bei dir vor Ort. Die Preise richten sich nach der Größe deines Fahrzeugs.",
    calc_eyebrow: "Preisrechner",
    calc_title: "Berechne deinen voraussichtlichen Preis",
    calc_sub: "Fahrzeug wählen, Leistung aussuchen – du siehst sofort eine ehrliche Richtpreiseinschätzung.",
    process_eyebrow: "Ablauf",
    process_title: "So einfach kommt dein Auto zum Glanz.",
    process_sub:
      "Vier Schritte von der Anfrage bis zum sauberen Innenraum – ohne dass du deine Haustür verlässt.",
    about_eyebrow: "Über mich",
    gallery_eyebrow: "Referenzen",
    gallery_title: "Echte Vorher/Nachher-Ergebnisse.",
    gallery_sub: "Ein Blick auf meine Arbeit sagt mehr als jedes Versprechen.",
    gallery_note: "Eigene Arbeitsproben – keine Stockfotos.",
    reviews_eyebrow: "Bewertungen",
    reviews_title: "Was Kunden sagen.",
    reviews_sub: "Nur echte, von mir eingetragene Bewertungen – keine erfundenen Stimmen.",
    faq_eyebrow: "FAQ",
    faq_title: "Gut zu wissen.",
    faq_sub: "Die häufigsten Fragen rund um deinen Termin – und die ehrlichen Antworten.",
    booking_eyebrow: "Terminanfrage",
    booking_title: "Sag mir, was dein Auto braucht.",
    booking_sub:
      "Unverbindliche Anfrage schicken – ich melde mich so schnell wie möglich mit einer Rückmeldung zu Termin und Preis. Oder du rufst direkt durch.",
    custom_package_title: "Individuelles Pflegepaket",
    custom_package_desc:
      "Ob nur die Sitze, nur Lederpflege oder das Rundum-Paket: Ich stelle dein Paket genau nach Wunsch und Zustand des Fahrzeugs zusammen. Sprich mich einfach an.",
    custom_package_tags: "Fleckenentfernung, Ozonbehandlung, Nach Wunsch",
    area_note_eyebrow: "Einsatzgebiet",
  },
  settings: {
    company_name: "Wiese-Fahrzeugpflege",
    owner_name: "Lukas Wiese",
    email: "info@wiesefahrzeugpflege.de",
    phone_display: "01590 6766314",
    phone_href: "015906766314",
    whatsapp: "",
    area: "Rotenburg (Wümme) & Umgebung",
    address: "Brockeler Str. 14B, 27356 Rotenburg",
    instagram: "https://www.instagram.com/wiesefahrzeugpflege/",
    tiktok: "https://www.tiktok.com/@wiesefahrzeugpflege",
    response_time: "",
    hours: [{ label: "Termine", value: "nach Vereinbarung" }],
  },
  service_area: {
    origin: "Rotenburg (Wümme)",
    free_radius_km: null,
    travel_fee: "",
    max_radius_km: 50,
    places: [],
    note: "",
  },
  about: {
    heading: "Persönlich. Bodenständig. Sauber.",
    text: "Mein Fokus liegt bewusst auf dem Innenraum des Fahrzeugs: Sitze, Polster, Teppiche und Armaturen – gründlich gereinigt und gepflegt, damit du dich in deinem Auto wieder wohlfühlst. Du hast einen festen Ansprechpartner: von der ersten Anfrage bis zur fertigen Aufbereitung.",
    photo_url: "",
    facts: [],
    workflow: "",
  },
  packages: [
    {
      id: "aufbereitung",
      name: "Innenraumaufbereitung",
      desc: "Die komplette Tiefenpflege: Sitze, Teppiche und Kofferraum werden gesaugt und gereinigt, Armaturen aufbereitet, Scheiben von innen poliert – auf Wunsch mit Polster- und Lederpflege. Hygienisch, werterhaltend, verkaufsfertig.",
      includes: ["Sitzreinigung", "Teppich-Tiefenreinigung", "Lederpflege"],
      prices: { s: 129, m: 149, l: 179, xl: 219 },
      durations: { s: 180, m: 240, l: 300, xl: 360 },
      image_url: IMAGES.aufbereitung,
      featured: true,
      note: "",
      surcharges: [],
      optional_addon_ids: ["fussmatten", "sitz", "leder", "kofferraum", "ozon", "obd"],
    },
    {
      id: "reinigung",
      name: "Innenraumreinigung",
      desc: "Die schnelle, regelmäßige Grundreinigung: Saugen von Sitzen, Fußmatten und Teppichen, Armaturen und Displays abwischen, Scheiben von innen – ohne Tiefenpflege.",
      includes: [],
      prices: { s: 59, m: 69, l: 79, xl: 89 },
      durations: { s: 75, m: 90, l: 105, xl: 120 },
      image_url: IMAGES.reinigung,
      featured: false,
      note: "",
      surcharges: [],
      optional_addon_ids: ["fussmatten", "sitz", "kofferraum", "ozon", "obd"],
    },
  ],
  addons: [
    { id: "fussmatten", name: "Fußmatten aufbereiten", desc: "Gründliche Reinigung & Auffrischung – ideal bei starken Verschmutzungen oder Salzrückständen.", price: 10, minutes: 15, per_seat: false, active: true, order: 1, prices_per_class: {} },
    { id: "sitz", name: "Einzelsitz-Polsterreinigung", desc: "Tiefenreinigung von Textil- oder Stoffsitzen – entfernt hartnäckige Flecken und Gerüche.", price: 15, minutes: 20, per_seat: true, active: true, order: 2, prices_per_class: {} },
    { id: "leder", name: "Lederpflege", desc: "Sanfte Reinigung und intensive Pflege – schützt und erhält die Geschmeidigkeit des Leders.", price: 30, minutes: 30, per_seat: false, active: true, order: 3, prices_per_class: {} },
    { id: "kofferraum", name: "Kofferraum intensiv reinigen", desc: "Saugen, Wischen und Detailpflege im gesamten Kofferraum – auch für stark beanspruchte Flächen.", price: 20, minutes: 20, per_seat: false, active: true, order: 4, prices_per_class: {} },
    { id: "ozon", name: "Ozon-Geruchsentfernung", desc: "Wirkt gegen hartnäckige Gerüche im gesamten Innenraum.", price: 49, minutes: 30, per_seat: false, active: true, order: 5, prices_per_class: {} },
    { id: "obd", name: "Fehlerspeicher auslesen & löschen", desc: "OBD-Diagnose vor Ort: Fehlerspeicher auslesen, Codes erklären, Bericht aushändigen – sporadische Fehler löschen wir nach Absprache. Diagnose-Service, keine Reparatur.", price: 19.99, minutes: 20, per_seat: false, active: true, order: 6, prices_per_class: {} },
  ],
  faq: [
    { id: "f1", q: "Brauche ich Strom oder Wasseranschluss?", a: "Ja, ein normaler Stromanschluss (z. B. Steckdose an Haus oder Garage) wird benötigt – das ist aber auch schon alles. Wasser, Equipment und geprüfte Pflegemittel bringe ich komplett selbst mit. Du musst nur deinen Schlüssel übergeben.", active: true },
    { id: "f2", q: "Wo arbeitest du?", a: "In Rotenburg (Wümme) und Umgebung – bei dir zu Hause, auf der Arbeit oder wo dein Fahrzeug gerade steht. Details zum Einsatzgebiet findest du beim Anfrageformular.", active: true },
    { id: "f3", q: "Wie lange dauert eine Innenraumaufbereitung?", a: "Je nach Fahrzeuggröße und Zustand etwa 2,5 bis 5 Stunden. Eine Innenraumreinigung ist meist in rund 1 bis 2 Stunden erledigt.", active: true },
    { id: "f4", q: "Was kostet mein Innenraum?", a: "Die Innenraumreinigung startet bei 59 €, die komplette Innenraumaufbereitung bei 129 € – je nach Fahrzeuggröße. Mit dem Preisrechner bekommst du eine ehrliche Richtpreiseinschätzung; den endgültigen Preis bestätige ich nach Abstimmung zum Fahrzeugzustand vor dem Termin.", active: true },
    { id: "f5", q: "Wie läuft das Auslesen des Fehlerspeichers ab?", a: "Ich schließe ein OBD-Diagnosegerät an dein Fahrzeug an, lese die Fehlercodes aus, erkläre dir deren Bedeutung und händige dir einen Bericht aus. Sporadische Fehler lösche ich nach Absprache. Wichtig: Das ist eine Diagnose – die Behebung einer Ursache ist damit nicht abgedeckt; bei hartnäckigen Fehlern empfehle ich die Werkstatt.", active: true },
    { id: "f6", q: "Ist die Anfrage verbindlich?", a: "Nein, die Anfrage ist unverbindlich. Ich melde mich mit einer Rückmeldung zu Termin und Preis und wir stimmen alles ab.", active: true },
  ],
  gallery: [],
  reviews: [],
};

export function mergeContent(stored) {
  const out = {};
  for (const key of Object.keys(DEFAULT_CONTENT)) {
    const d = DEFAULT_CONTENT[key];
    const s = stored?.[key];
    if (s === undefined || s === null) {
      out[key] = d;
    } else if (Array.isArray(d)) {
      out[key] = Array.isArray(s) ? s : d;
    } else if (typeof d === "object") {
      out[key] = { ...d, ...(typeof s === "object" && !Array.isArray(s) ? s : {}) };
    } else {
      out[key] = s;
    }
  }
  if (stored?.packages?.length) out.packages = stored.packages;
  if (stored?.addons?.length) out.addons = stored.addons;
  if (stored?.faq?.length) out.faq = stored.faq;
  return out;
}

export function activeAddons(content) {
  return content.addons
    .filter((a) => a.active !== false)
    .sort((a, b) => (a.order ?? 99) - (b.order ?? 99));
}

export function buildServiceOptions(content) {
  const options = content.packages.map((p) => p.name);
  options.push(content.texts.custom_package_title || "Individuelles Pflegepaket");
  const obd = content.addons.find((a) => a.id === "obd" && a.active !== false);
  if (obd) options.push(obd.name);
  return options;
}

export function buildTelLink(settings) {
  const href = (settings?.phone_href || "").trim();
  if (!href || href.replace(/[^0-9+]/g, "").length < 6) return null;
  return `tel:${href.replace(/\s+/g, "")}`;
}

export function buildWhatsLink(settings) {
  const wa = (settings?.whatsapp || "").replace(/[^0-9]/g, "");
  if (wa.length < 8) return null;
  return `https://wa.me/${wa}`;
}

export function formatEur(n) {
  const num = Number(n) || 0;
  const decimals = Number.isInteger(num) ? 0 : 2;
  return `${num.toLocaleString("de-DE", { minimumFractionDigits: decimals, maximumFractionDigits: decimals })} €`;
}

export function formatDuration(minutes) {
  if (minutes >= 120) {
    const h = Math.round((minutes / 60) * 10) / 10;
    return `ca. ${String(h).replace(".", ",")} Std.`;
  }
  return `ca. ${minutes} Min.`;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset: -72, duration: 1.1 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
